module.exports = __webpack_public_path__ + "img/calendar-grey.e000ba3a.svg";